import { PagedRequestType, PagedResultsType } from "../../../types/PagedResults";
import { StudentSubjectGradeType } from "../../../types/StudentSubjectGrade";
import { SubjectType } from "../../../types/Subject";
import { SubjectPlanType } from "../../../types/SubjectPlan";
import { get } from "../../../utils/axios-config";
import { SUBJECTS,SUBJECTS_APPROVED,SUBJECTS_PLAN,SUBJECTS_REPROVED } from "../../../utils/constants";


export const getSubjects = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.idScientificArea ? { IdScientificArea: data.idScientificArea } : {}),
    });
    const url = `${SUBJECTS}?${queryParams.toString()}`;
    return await get<PagedResultsType<SubjectType>>(url)
};

export const getSubjectsReprovedQuery = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
       ...(data?.StudentCode ? { StudentCode: data.StudentCode } : {}),
        ...(data?.IdStudent ? { IdStudent: data.IdStudent } : {}),
    });
    if (data?.Year) {
        queryParams.append('Year', `${data?.Year}`);
    }
    if (data?.Semester) {
        queryParams.append('Semester', `${data?.Semester}`);
    }
    const url = `${SUBJECTS_REPROVED}?${queryParams.toString()}`;
    return await get<PagedResultsType<StudentSubjectGradeType>>(url)
};
export const getSubjectsAprovedQuery = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
       // ...(data?.IdAcademicYear ? { IdAcademicYear: data.IdAcademicYear } : {}),
        ...(data?.IdStudent ? { IdStudent: data.IdStudent } : {}),
        
    });
    if (data?.Year) {
        queryParams.append('Year', `${data?.Year}`);
    }
    if (data?.Semester) {
        queryParams.append('Semester', `${data?.Semester}`);
    }
    const url = `${SUBJECTS_APPROVED}?${queryParams.toString()}`;
    return await get<PagedResultsType<StudentSubjectGradeType>>(url)
};

export const getSubjectsPlans = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.IdAcademicYear ? { IdAcademicYear: data.IdAcademicYear } : {}),
        ...(data?.IdClass ? { IdClass: data.IdClass } : {}),
        ...(data?.IdCourse ? { IdCourse: data.IdCourse } : {}),
        ...(data?.IdTeacher ? { IdTeacher: data.IdTeacher } : {}),
        ...(data?.IdSubject ? { IdSubject: data.IdSubject } : {}),
        ...(data?.IdPlan ? { IdPlan: data.IdPlan } : {}),
    });
    const url = `${SUBJECTS_PLAN}?${queryParams.toString()}`;
    return await get<PagedResultsType<SubjectPlanType>>(url)
};
